import App from './App.vue'
import '@/styles/main.scss'
import '@vuepic/vue-datepicker/dist/main.css'
import { createApp } from 'vue'
import Keycloak from 'keycloak-js'
import { useUserStore } from '@/stores/user'
import { defineCustomElement as defineEvidenceOneChat } from '@evidenceone/chat-widget/components/evidenceone-chat'

// Register <evidenceone-chat> (and its nested components) once, using the
// custom-elements build so everything is bundled into the app. The lazy
// `/loader` build fetches `.entry.js` chunks at runtime, which 404 in a bundled
// production SPA (works in dev, breaks on deploy). This build has no runtime fetch.
defineEvidenceOneChat()

// Suprimir erros conhecidos do ResizeObserver que não afetam a funcionalidade
// Este é um problema conhecido do browser quando ResizeObserver detecta mudanças
// que causam outras mudanças, mas não afeta o comportamento da aplicação
// const suppressResizeObserverErrors = () => {
//   const originalError = console.error
//   console.error = (...args) => {
//     const errorMessage =
//       typeof args[0] === 'string'
//         ? args[0]
//         : args[0]?.message || args[0]?.toString() || ''

//     if (
//       errorMessage.includes('ResizeObserver loop limit exceeded') ||
//       errorMessage.includes(
//         'ResizeObserver loop completed with undelivered notifications',
//       )
//     ) {
//       return
//     }
//     originalError.apply(console, args)
//   }

//   // Também capturar erros não tratados
//   window.addEventListener('error', (e) => {
//     if (
//       e.message ===
//         'ResizeObserver loop completed with undelivered notifications' ||
//       e.message === 'ResizeObserver loop limit exceeded'
//     ) {
//       e.stopImmediatePropagation()
//       return false
//     }
//   })
// }

// Inicializar supressão de erros do ResizeObserver
// suppressResizeObserverErrors()

// Dynamic imports para reduzir o bundle inicial
const VueDatePicker = () => import('@vuepic/vue-datepicker')

const keycloakOpts = {
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  onLoad: 'login-required',
}

const keycloak = new Keycloak(keycloakOpts)

async function setUserData(tokenParsed) {
  const userStore = useUserStore()
  userStore.loadUserProfile(tokenParsed)
  userStore.updateUserRoles(tokenParsed.realm_access.roles)
  userStore.updateUserGroups(tokenParsed.groups)
  await userStore.syncMySubscription()
}

keycloak
  .init({ onLoad: keycloakOpts.onLoad })
  .then(async (auth) => {
    if (!auth) {
      window.location.reload()
    } else {
      console.info('User authenticated')
      window.tokenParsed = keycloak.tokenParsed
      window.accessToken = keycloak.token

      async function bootstrap() {
        // if (import.meta.env.DEV) {
        //   const { worker } = await import("./mocks/browser");
        //   await worker.start({
        //     onUnhandledRequest: "bypass",
        //     serviceWorker: {
        //       url: "/mockServiceWorker.js",
        //     },
        //   });
        // }

        const app = createApp(App)
        app.provide('$keycloak', keycloak)

        // Carregar plugins dinamicamente
        const { registerPlugins } = await import('@/plugins')
        await registerPlugins(app)

        // Carregar VueDatePicker dinamicamente
        const VueDatePickerComponent = await VueDatePicker()
        app.component('VueDatePicker', VueDatePickerComponent.default || VueDatePickerComponent)

        await setUserData(keycloak.tokenParsed)

        // await userStore.loadUserPermissions()

        // Garantir que o i18n seja sincronizado após a montagem da app
        app.mount('#app')

        // Inicializar store de idiomas após carregar perfil do usuário e montar a app
        const { useLanguageStore } = await import('@/stores/language')
        const languageStore = useLanguageStore()

        // Definir a instância do i18n no language store
        const { default: i18n } = await import('@/i18n')
        languageStore.setI18nInstance(i18n)
        languageStore.initializeLanguages()

        // Sincronizar i18n após a app estar montada
        setTimeout(() => {
          languageStore.syncWithI18n()
        }, 500)
      }

      await bootstrap()
    }

    setInterval(() => {
      keycloak
        .updateToken(70)
        .then((refreshed) => {
          if (refreshed) {
            console.info('Token refreshed')
            window.accessToken = keycloak.token
            window.tokenParsed = keycloak.tokenParsed

            setUserData(keycloak.tokenParsed)

            const userStore = useUserStore()
            if (
              userStore.isProfessionalHealthCare &&
              window.location.pathname === '/payment-wall'
            ) {
              window.location.href = '/'
            }
          }
        })
        .catch((error) => {
          console.error('Failed to refresh token: ', error)
        })
    }, 1000 * 60)
  })
  .catch((e) => {
    console.log('error:', e)
    console.error('User authentication failed')
  })
